import { RCXAdapter } from 'rcx_adapter';

import { ServiceNowAdapter } from './adapter';
import { ServiceNowAdapterEvent } from './enums';
import { ModuleBaseOption } from './interfaces/module';
import CallLogModule from './modules/CallLog';
import CommonModule from './modules/Common';
import CreateEntityRecord from './modules/CreateEntityRecord';
import DialModule from './modules/Dial';
import DigitalLog from './modules/DigitalLog';
import OnCallMatch from './modules/OnCallMatch';
import OnDigitalMatch from './modules/OnDigitalMatch';
import OnLeadSelected from './modules/OnLeadSelected';
import OnSendToCpr from './modules/OnSendToCpr';
import OnStateChange from './modules/OnStateChange';
import PopRecord from './modules/PopRecord';

function setup() {
    const mAdapter = window.rcServiceNowAdapter as ServiceNowAdapter;
    mAdapter.on(ServiceNowAdapterEvent.RINGCX_FRAME_LOAD, (appIFrame: HTMLIFrameElement) => {
        RCXAdapter.instance().init(appIFrame);
        const moduleOptions: ModuleBaseOption = {
            rcxAdapter: RCXAdapter.instance(),
            serviceNowAdapter: mAdapter,
        };
        applicationStart(moduleOptions);
    });
}

function applicationStart(moduleOptions: ModuleBaseOption) {
    CallLogModule.init(moduleOptions).start();
    DialModule.init(moduleOptions).start();
    CommonModule.init(moduleOptions).start();
    OnCallMatch.init(moduleOptions).start();
    CreateEntityRecord.init(moduleOptions).start();
    DigitalLog.init(moduleOptions).start();
    OnDigitalMatch.init(moduleOptions).start();
    OnLeadSelected.init(moduleOptions).start();
    OnSendToCpr.init(moduleOptions).start();
    PopRecord.init(moduleOptions).start();
    OnStateChange.init(moduleOptions).start();
}

export default setup;
